module.exports = __webpack_public_path__ + "img/warnings-07.ed82f797.png";